export default __webpack_public_path__ + "static/media/ep2collage1.ecad1745.jpg";